<template>
    <div>
        <hero-bar :has-right-visible="false" menu-icon="desktop-mac">
            {{ $lang.Menus.MyProjects }}
        </hero-bar>

        <div class="section is-main-section">
            <!-- Widths: the two names share what is left; the rest are fixed (_data-table.scss). -->
            <b-table class="data-table"
                     style="--table-min: 1012px; --m-cols: 3"
                     :data="projectsdata"
                     :mobile-sort-placeholder="$lang.MyProjects.SortBy"
                     :paginated="isPaginated"
                     :per-page="perPage"
                     hoverable>
                <b-table-column field="ProjectName" :label="$lang.MyProjects.ProjectName" v-slot="props" cell-class="cell-strong m-title">
                    {{ props.row.ProjectName }}
                </b-table-column>
                <b-table-column field="PanelName" :label="$lang.MyProjects.PanelName" v-slot="props" cell-class="m-sub">
                    {{ props.row.PanelName }}
                </b-table-column>
                <b-table-column field="PanelNo" :label="$lang.MyProjects.PanelNo" v-slot="props" width="112" numeric>
                    {{ props.row.PanelNo }}
                </b-table-column>
                <b-table-column field="EyeNumber" :label="$lang.ProjectInfos.EyeNumber + ' / ' + $lang.ProjectInfos.TotalEyesNumber" v-slot="props" width="184" numeric>
                    {{ props.row.EyeNo }} / {{ props.row.TotalEyesNumber }}
                </b-table-column>
                <b-table-column field="ReportDate" :label="$lang.MyProjects.Date" v-slot="props" width="134" numeric sortable :custom-sort="sortByReportDate">
                    {{ props.row.ReportDate }}
                </b-table-column>

                <!--
                    Five fixed slots, so the icons line up from row to row: a row without an
                    action keeps its slot empty. On a phone the empty ones drop out and the
                    rest carry their names. Which actions show is the code's rule, not the
                    design's (the design shows Sil on every row).
                -->
                <b-table-column field="Action" v-slot="props" width="270">
                    <div class="row-actions">
                        <button class="button row-action" :title="$lang.MyProjects.Edit" @click="openProjectDetail(props.row)">
                            <span class="mdi mdi-pencil" aria-hidden="true"></span>
                            <span class="row-action-label">{{ $lang.MyProjects.Edit }}</span>
                        </button>
                        <button class="button row-action" :title="$lang.MyProjects.Copy" @click="copyProjectDetail(props.row)">
                            <span class="mdi mdi-content-copy" aria-hidden="true"></span>
                            <span class="row-action-label">{{ $lang.MyProjects.Copy }}</span>
                        </button>
                        <button class="button row-action is-destructive"
                                :class="{ 'is-empty': !(props.row.IsCompleted == 0 || isAdmin == 1) }"
                                :title="$lang.MyProjects.Delete"
                                @click="deleteProject(props.row)">
                            <span class="mdi mdi-delete" aria-hidden="true"></span>
                            <span class="row-action-label">{{ $lang.MyProjects.Delete }}</span>
                        </button>
                        <button class="button row-action"
                                :class="{ 'is-empty': props.row.IsCompleted != 1 }"
                                :title="$lang.MyProjects.Report"
                                @click="openPdf(props.row)">
                            <span class="mdi mdi-file-pdf" aria-hidden="true"></span>
                            <span class="row-action-tag">PDF</span>
                            <span class="row-action-label">{{ $lang.MyProjects.Report }}</span>
                        </button>
                        <button class="button row-action"
                                :class="{ 'is-empty': props.row.IsValid }"
                                :title="$lang.MyProjects.FanReport"
                                @click="openFanPdf(props.row)">
                            <span class="mdi mdi-file-pdf" aria-hidden="true"></span>
                            <span class="row-action-tag">FAN</span>
                            <span class="row-action-label">{{ $lang.MyProjects.FanReport }}</span>
                        </button>
                    </div>
                </b-table-column>

                <template #empty>
                    <p class="table-empty">{{ $lang.MyProjects.Empty }}</p>
                </template>

                <template #bottom-left>
                    {{ projectsdata.length }} {{ $lang.MyProjects.CountSuffix }}
                </template>
            </b-table>
        </div>
    </div>
</template>

<script>
    import router from '@/router';
    import api from '@/api';
    import { toCurrentLabel } from '@/constants/protectionClass';

    export default {
        name: 'MyProjects',
        data() {
            return {
                isActive: true,
                isLoading: false,
                isPaginated: true,
                perPage: 10,
                showWeekNumber: false,
                enableSeconds: false,
                hourFormat: undefined, // Browser locale
                locale: undefined, // Browser locale
                firstDayOfWeek: undefined, // 0 - Sunday
                projectsdata: [],
                isAdmin: ''
            }
        },
        mounted() {
            this.$store.state.isFooterFixed = true;
            this.getProjectsTable();
            this.isAdmin = this.$store.state.isAdmin;
        },
        destroyed() {
            this.$store.state.isFooterFixed = false;
        },
        methods: {
            getOutputCircNumber() {
                api.panels.getMaxCircuitIndex_OutputCircuitCalculationDevices(this.$store.state.projectId).then((res) => {
                    if (res.isError) {
                        console.log("error ");
                    } else {
                        if (res.data == null || res.data == 0) {
                            this.$store.state.circIndex = 1;
                        } else {
                            this.$store.state.circIndex = res.data + 1;
                        }
                    }
                });
            },

            openProjectDetail(row) {
                this.$store.state.projectId = row.ProjectId;
                this.$store.state.isPrevProject = true;
                this.$store.activeStep = 0;
                this.$store.state.calcIndex = row.CalcTypeId;
                if (this.$store.state.calcIndex == 3) {
                    this.getOutputCircNumber();
                } else {
                    this.$store.state.circIndex = 0;
                }
                this.$store.canPanelInfosOpen = false;
                this.$store.canEnvConditionsOpen = false;
                this.$store.canCalculationOpen = false;
                this.$store.canResultOpen = false;
                this.$store.canReportPageOpen = false;
                this.$store.canFanCalcOpen = false;
                this.$store.state.isEdit = true;

                this.$store.state.areHiddenStepsVisible = false;

                var payload = { langCode: this.$lang.Format.Lang, projectName: row.ProjectName, panelName: row.PanelName, panelNo: row.PanelNo, lastUserName: row.LastUserName, panelManifacturer: row.PanelManifacturer, ratedCurrentIndex: row.RatedCurrentIndex, panelRatedCurrent: row.PanelRatedCurrent, totalEyesNumber: row.TotalEyesNumber, eyesNumber: row.EyeNo, isCompleted: row.IsCompleted };
                this.$store.commit('setProjectInfos', payload);

                var payload2 = { panelType: row.PanelType, panelTypeIndex: row.PanelTypeId, panelDimension: row.PanelDimension, panelIP: toCurrentLabel(row.IP), selectedIP_Id: 0, Sair: row.Sair, surfaceExplanation: row.SurfaceInfo, virtualSurface: row.VirtualSurface, virtualSurfaceIndex: row.VirtualSurfaceIndex, virtualSurfaceOption: row.VirtualSurfaceOption, seperationNumber: row.SeperationNumber, ae_value: row.Ae, ae_valueList: [] };
                this.$store.commit('setPanelInfos', payload2);

                var payload3 = { envTemperature: row.Ta, maxTemperature: row.Tmax, humidity: "", altitude: row.Altitude };
                this.$store.commit('setEnvConditionDatas', payload3);

                var payload4 = { totalLostPower_1: row.KnownLostPower };
                this.$store.commit('setCalculationDatas', payload4);

                var payload5 = { inPanelTemperature: row.InPanelTemp, envMeasureTemperature: row.InEnvTemp, totalLostPower_2: row.InPanelLostPower };
                this.$store.commit('setCalculationDatas_2', payload5);

                var payload6 = { InputCircuitDef: "", P_InputCircuit: 0, totalLostPower_3: 0 };
                this.$store.commit('set_Datas_InputCircuits', payload6);

                var payload7 = { OutputCircuitDef: "", P_OutputCircuit: 0, totalLostPower_3: 0 };
                this.$store.commit('set_Datas_OutputCircuits', payload7);

                var payload8 = { ManuelCircuitDef: "", P_ManuelCircuit: 0, totalLostPower_3: 0 };
                this.$store.commit('set_Datas_ManuelCircuits', payload8);

                var payload9 = { envTemperature: 0, maxTemperature: 0, P_890: 0, P_Total: 0, result_630A: 0 };
                this.$store.commit('setResultInfos_630A', payload9);

                var payload10 = { value_k: 0, n_value: 0, value_d: 0, value_x: 0, deltaT_0_5: 0, Ab_val: 0, height_val: 0, value_f: 0, value_g: 0, value_c: 0, deltaT_0_75: 0, deltaT_1: 0, result_1600A: 0 };
                this.$store.commit('setResultInfos_1600A', payload10);

                this.$store.activeStep = 0;
                router.push('/projectInfos');
            },

            copyProjectDetail(row) {
                this.$store.state.isPrevProject = false;
                this.$store.activeStep = 0;
                this.$store.state.calcIndex = row.CalcTypeId;
                if (this.$store.state.calcIndex == 3) {
                    this.getOutputCircNumber();
                } else {
                    this.$store.state.circIndex = 0;
                }
                this.$store.canPanelInfosOpen = false;
                this.$store.canEnvConditionsOpen = false;
                this.$store.canCalculationOpen = false;
                this.$store.canResultOpen = false;
                this.$store.canReportPageOpen = false;
                this.$store.canFanCalcOpen = false;
                this.$store.state.isCopyProject = true;
                this.$store.state.isEdit = false;

                var uuid = this.generateUUID();
                this.$store.state.projectId = uuid + "_Temp";


                this.$store.state.areHiddenStepsVisible = false;

                var copyProjectName = row.ProjectName + '_copy'; 

                var payload = { langCode: this.$lang.Format.Lang, projectName: copyProjectName, panelName: row.PanelName, panelNo: row.PanelNo, lastUserName: row.LastUserName, panelManifacturer: row.PanelManifacturer, ratedCurrentIndex: row.RatedCurrentIndex, panelRatedCurrent: row.PanelRatedCurrent, totalEyesNumber: row.TotalEyesNumber, eyesNumber: row.EyeNo, isCompleted: false };
                this.$store.commit('setProjectInfos', payload);

                var payload2 = { panelType: row.PanelType, panelTypeIndex: row.PanelTypeId, panelDimension: row.PanelDimension, panelIP: toCurrentLabel(row.IP), selectedIP_Id: 0, Sair: row.Sair, surfaceExplanation: row.SurfaceInfo, virtualSurface: row.VirtualSurface, virtualSurfaceIndex: row.VirtualSurfaceIndex, virtualSurfaceOption: row.VirtualSurfaceOption, seperationNumber: row.SeperationNumber, ae_value: row.Ae, ae_valueList: [] };
                this.$store.commit('setPanelInfos', payload2);

                var payload3 = { envTemperature: row.Ta, maxTemperature: row.Tmax, humidity: "", altitude: row.Altitude };
                this.$store.commit('setEnvConditionDatas', payload3);

                var payload4 = { totalLostPower_1: row.KnownLostPower };
                this.$store.commit('setCalculationDatas', payload4);

                var payload5 = { inPanelTemperature: row.InPanelTemp, envMeasureTemperature: row.InEnvTemp, totalLostPower_2: row.InPanelLostPower };
                this.$store.commit('setCalculationDatas_2', payload5);

                var payload6 = { InputCircuitDef: "", P_InputCircuit: 0, totalLostPower_3: 0 };
                this.$store.commit('set_Datas_InputCircuits', payload6);

                var payload7 = { OutputCircuitDef: "", P_OutputCircuit: 0, totalLostPower_3: 0 };
                this.$store.commit('set_Datas_OutputCircuits', payload7);

                var payload8 = { ManuelCircuitDef: "", P_ManuelCircuit: 0, totalLostPower_3: 0 };
                this.$store.commit('set_Datas_ManuelCircuits', payload8);

                var payload9 = { envTemperature: 0, maxTemperature: 0, P_890: 0, P_Total: 0, result_630A: 0 };
                this.$store.commit('setResultInfos_630A', payload9);

                var payload10 = { value_k: 0, n_value: 0, value_d: 0, value_x: 0, deltaT_0_5: 0, Ab_val: 0, height_val: 0, value_f: 0, value_g: 0, value_c: 0, deltaT_0_75: 0, deltaT_1: 0, result_1600A: 0 };
                this.$store.commit('setResultInfos_1600A', payload10);

                this.$store.activeStep = 0;
                router.push('/projectInfos');
            },

            // GetProjects(memberId) sends ReportDate as dd-MM-yyyy, which as text sorts by the
            // day of the month; compare it as yyyyMMdd instead.
            sortByReportDate(a, b, isAsc) {
                const key = (row) => (row.ReportDate || '').split('-').reverse().join('');
                const order = key(a).localeCompare(key(b));
                return isAsc ? order : -order;
            },
            getProjectsTable() {
                this.projectsdata = [];
                api.panels.getProjects(this.$store.state.memberId + '').then((res) => {
                    if (res.isError) {
                        console.log("error ");
                    } else {
                        res.data.forEach((e) => {
                            this.projectsdata.push(e);
                        });
                    }
                });
            },
            deleteProject(row) {
                this.$buefy.dialog.confirm({
                    title: this.$lang.DeleteDialog.Title,
                    message: this.$lang.DeleteDialog.Message_4,
                    confirmText: this.$lang.DeleteDialog.Confirm_4,
                    cancelText: this.$lang.DeleteDialog.Cancel,
                    type: 'is-danger',
                    hasIcon: true,
                    onConfirm: () =>
                        api.panels.deleteProject(row.ProjectId).then((res) => {
                            if (res.isError) {
                                this.$buefy.dialog.alert(this.$errorModal(res));
                            } else {
                                // DeleteProject removes the project and its seven calculation
                                // tables in one transaction; a second round of deletes followed,
                                // for a project that no longer existed.
                                this.$buefy.toast.open(this.$lang.DeleteDialog.Deleted);
                                this.getProjectsTable();
                            }
                        })
                })
            },
            openPdf(row) {
                this.$store.state.isPrevProject = true;
                this.$store.state.projectId = row.ProjectId;

                router.push('/reportPdfPage2');
            },

            openFanPdf(row) {
                this.$store.state.isPrevProject = true;
                this.$store.state.projectId = row.ProjectId;

                router.push('/FanPdfPage');
            },

            openInfo() {
                if (!this.isInfoOpened) {
                    this.isInfoOpened = true;
                } else {
                    this.isInfoOpened = false;
                }
            },

            columnTdAttrs(row, column) {
                if (row.id === 'Total') {
                    if (column.label === 'ID') {
                        return {
                            colspan: 4,
                            class: 'has-text-weight-bold',
                            style: {
                                'text-align': 'left !important'
                            }
                        }
                    } else if (column.label === 'Gender') {
                        return {
                            class: 'has-text-weight-semibold'
                        }
                    } else {
                        return {
                            style: { display: 'none' }
                        }
                    }
                }
                return null
            },

            generateUUID() {
                var d = new Date().getTime(); // Timestamp
                var d2 = ((typeof performance !== 'undefined') && performance.now && (performance.now() * 1000)) || 0; // Time in microseconds since page-load or 0 if unsupported
                return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                    var r = Math.random() * 16; // random number between 0 and 16
                    if (d > 0) { // Use timestamp until depleted
                        r = (d + r) % 16 | 0;
                        d = Math.floor(d / 16);
                    } else { // Use microseconds since page-load if supported
                        r = (d2 + r) % 16 | 0;
                        d2 = Math.floor(d2 / 16);
                    }
                    return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
                });
            },
        }
    };
</script>
